import { useEffect } from 'react';

import settings from '@/constants/constants';
import datadog from '@/providers/datadog';
import configureGTM from '@/providers/googleTagManager';
import useFeatureFlags from './useFeatureFlags';

export default function useTrackingProviders({ ready }: { ready: boolean }) {
  const { flags } = useFeatureFlags();

  // Called when the feature flag loading state changes.
  useEffect(() => {
    if (ready) {
      datadog(flags, settings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, ready]);

  // Called only when settings change
  useEffect(() => {
    configureGTM(settings);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  return {};
}
